var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-container',[_c('vs-flex',{attrs:{"wrap":false,"items":"center","justify":"between"}},[_c('vs-flex-item',[_c('logo',{attrs:{"height":{ all: 'md', xl: 'auto' }}})],1),_vm._v(" "),_c('vs-flex-item',[_c('menu-actions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }